export type MenuItems = {
  label: string;
  icon: JSX.Element | string;
  path: string;
  allowedRoles?: string[];
  subMenu?: {
    label: string;
    path: string;
  }[];
};

export const menuItems: MenuItems[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "pi pi-home",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "My Services",
    path: "/dashboard/services",
    icon: "pi pi-objects-column",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  {
    label: "Transactions history",
    path: "/dashboard/history",
    icon: "pi pi-history",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
  /*{
    label: "Withdrawal history",
    path: "/dashboard/withdrawal-list",
    icon: "pi pi-money-bill",
  },
  {
    label: "Payment Link",
    path: "/dashboard/payment-link",
    icon: "pi pi-link",
  },
  {
    label: "Manage webhook",
    path: "/dashboard/manage-webhook",
    icon: "pi pi-send",
  },*/
  {
    label: "Settings",
    path: "/dashboard/settings",
    icon: "pi pi-cog",
    allowedRoles: ["ENTERPRISE", "CUSTOMER", "SUPERADMIN", "ADMIN", "REVIEWER"],
  },
  {
    label: "Developers",
    path: "/dashboard/developers",
    icon: "pi pi-code",
    allowedRoles: ["ENTERPRISE", "CUSTOMER"],
  },
];
